
  import { defineComponent } from 'vue';
  import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
  import { START_FREE_TRIAL_MODAL_WIDTH } from './constants';
  import { Button } from '@/ui/components/Button';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';

  interface FreeTrialModalProps extends ModalProps{
    loading: boolean;
  }

  export default defineComponent<FreeTrialModalProps>({
    components: {
      Modal,
      Button,
      PageSubtitle,
    },
    props: [...modalProps, 'loading'],
    setup(_, { emit }) {
      const onCloseModal = () => {
        emit('close');
      };

      const onStartTrial = () => {
        emit('start-free-trial');
      };

      return {
        onCloseModal,
        onStartTrial,
        START_FREE_TRIAL_MODAL_WIDTH,
      };
    },
  });
